import list from './list'
import progress from './progress'
import details from './details'
import active from './active'
import summary from './summary'
import template from './template'
import failed from './failed'

export default { list, progress, details, active, summary, template, failed }
